<h2 mat-dialog-title>Edit Review Response</h2>

<mat-dialog-content [formGroup]="formGroup">
  <p>Please note that you can only post a single response per review, but you can always return here
    to modify your response.</p>
  <p>
    <mat-form-field hintLabel="Max 2000 characters" class="edit-review-response__textarea">
      <textarea matInput #response maxlength="2000" formControlName="responseText" name="responseField" [(ngModel)]="selectedResponse"></textarea>
      <mat-hint align="end">{{response.value?.length || 0}}/2000</mat-hint>
    </mat-form-field>
  </p>
  <p>Note: your first name and last initial will appear with your response.</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button type="submit" [disabled]="!formGroup.valid" cdkFocusInitial class="aopa-mat-btn aopa-mat-btn--outlined" (click)="save()">Post</button>
  <button mat-button mat-dialog-close class="aopa-mat-btn aopa-mat-btn--outlined" (click)="cancel()">Cancel</button>
</mat-dialog-actions>
